import { ExternalLink } from "lucide-react";
import { Button } from "@/components/ui/button";
import { CONTACT } from "@/constants/contact";

const partners = [
  {
    testid: "partner-brb-card",
    link: CONTACT.brbImportLink,
    linkTestid: "partner-brb-link",
    ctaTestid: "partner-brb-cta",
    img: "/images/brb-import.jpg",
    imgAlt: "BRB Import — import, courtage et dépôt-vente automobile, partenaire de MECA AUTO CLEAN 01",
    imgClass: "w-full",
    name: "BRB Import",
    text: "Import, courtage et dépôt-vente automobile : notre partenaire pour trouver ou vendre votre véhicule.",
    cta: "Visiter brbimports.com",
  },
  {
    testid: "partner-centralepneus-card",
    link: CONTACT.centralepneusLink,
    linkTestid: "partner-centralepneus-link",
    ctaTestid: "partner-centralepneus-cta",
    img: "/images/centralepneus.jpg",
    imgAlt: "Station montage partenaire Centralepneus.fr",
    imgClass: "h-48 w-auto",
    name: "Centralepneus.fr",
    text: "Station de montage partenaire : commandez vos pneus en ligne et faites-les monter dans notre garage à Pont-d'Ain.",
    cta: "Commander mes pneus",
  },
];

export const PartnerSection = () => (
  <section data-testid="partners-section" className="border-t border-border">
    <div className="mx-auto max-w-6xl px-4 py-20">
      <p className="mb-2 text-sm font-semibold uppercase tracking-[0.25em] text-primary">
        Nos partenaires
      </p>
      <h2 className="font-display text-3xl font-bold uppercase sm:text-4xl">
        Ils travaillent avec nous
      </h2>
      <div className="mt-12 grid gap-6 lg:grid-cols-2">
        {partners.map((p) => (
          <div
            key={p.name}
            data-testid={p.testid}
            className="flex flex-col overflow-hidden rounded-lg border border-border bg-card transition-colors card-lift hover:border-primary/50"
          >
            <a
              href={p.link}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={p.linkTestid}
              className="flex items-center justify-center bg-black"
            >
              <img src={p.img} alt={p.imgAlt} loading="lazy" className={p.imgClass} />
            </a>
            <div className="flex flex-1 flex-col p-6">
              <h3 className="font-display text-xl font-semibold uppercase">{p.name}</h3>
              <p className="mt-2 flex-1 text-sm text-muted-foreground">{p.text}</p>
              <Button asChild variant="outline" size="sm" className="mt-5 self-start" data-testid={p.ctaTestid}>
                <a href={p.link} target="_blank" rel="noopener noreferrer">
                  <ExternalLink className="mr-2 h-4 w-4" /> {p.cta}
                </a>
              </Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);
